export class Window
{
    protected cx     : number;
    protected cy     : number;
    protected height : number;
    protected _width  : number;

    constructor() {
        this.cx     = 0;
        this.cy     = 0;
        this.height = 0;
        this._width  = 0;
    }

    public setWindowRect(cx : number, cy : number, width : number, height : number)
    {
        this.cx     = cx;
        this.cy     = cy;
        this._width = width;
        this.height = height;
    }

    public get bottom() : number {
        return this.cy + this.height;
    }

    public get left() : number {
        return this.cx;
    }

    public get right() : number {
        return this.cx + this._width;
    }

    public get top() : number {
        return this.cy;
    }

    public get width() : number {
        return this._width;
    }
}

